import { filterBillingData } from 'reactApp/api/billing/data/BillingDataAPICall.filters';
import { BillingDataCoreApi } from 'reactApp/api/billing/data/BillingDataAPICall.makeRequest';
import {
    billingDataAllFallbackEnabled,
    billingDataOptimizationEnabled,
} from 'reactApp/appHelpers/featuresHelpers/features/billingDataEndpoint';

import { type BillingDataPeriods, BILLING_DATA_ALL_PERIOD } from './BillingDataAPICall.types';

const callApi = (period?: BillingDataPeriods) => {
    if (period === BILLING_DATA_ALL_PERIOD) {
        return BillingDataCoreApi.makeRequest({ period: billingDataAllFallbackEnabled ? period : undefined });
    }
    return BillingDataCoreApi.makeRequest({ period });
};

const billingDataCache: Record<BillingDataPeriods, ReturnType<typeof callApi> | null> = {
    current: null,
    past: null,
    future: null,
    [BILLING_DATA_ALL_PERIOD]: null,
};

const createBillingDataRequest = (fromCache: boolean) => (period: BillingDataPeriods) => {
    // TODO:  выпилить блок с if после ssr https://jira.vk.team/browse/CLOUDWEB-18818
    if (billingDataOptimizationEnabled) {
        if (!fromCache || !billingDataCache[period]) {
            billingDataCache[period] = callApi(period);
        }
        return billingDataCache[period] as ReturnType<typeof callApi>;
    }
    return callApi(period);
};

/** @description Только для тестов */
export const clearBillingDataCacheForTests = () => {
    billingDataCache.current = null;
    billingDataCache.past = null;
    billingDataCache.future = null;
    billingDataCache[BILLING_DATA_ALL_PERIOD] = null;
};

export const BillingDataAPI = {
    current: (fromCache: boolean) => filterBillingData(createBillingDataRequest(fromCache), 'current'),
    past: () => filterBillingData(createBillingDataRequest(true), 'past'),
    future: () => filterBillingData(createBillingDataRequest(true), 'future'),
} as const;
